import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";

const KonobarStats = ({ onBack }) => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("inventory")
      .select("*")
      .gt("sold_count", 0) // Uzmi samo ono što je prodano bar jednom
      .order("sold_count", { ascending: false });

    if (!error) setStats(data);
    setLoading(false);
  };

  const totalEarnings = stats.reduce(
    (acc, item) => acc + item.price * item.sold_count,
    0,
  );

  return (
    <div className="stats-wrapper">
      <div className="stats-header">
        <button className="back-btn-minimal" onClick={onBack}>
          <i className="fi fi-rs-arrow-left"></i> Idi natrag
        </button>
        <h2>STATISTIKA</h2>
      </div>

      <div className="total-card">
        <span>Ukupni Promet</span>
        <h1>{totalEarnings.toFixed(2)}€</h1>
      </div>

      <div className="stats-list">
        {stats.map((item) => (
          <div key={item.id} className="stats-item">
            <div className="item-info">
              <span className="item-name">{item.name}</span>
              <span className="item-details">
                Prodano: <strong>{item.sold_count} kom</strong> x{" "}
                {item.price.toFixed(2)}€
              </span>
            </div>
            <div className="item-total">
              {(item.price * item.sold_count).toFixed(2)}€
            </div>
          </div>
        ))}
      </div>

      {stats.length === 0 && !loading && (
        <div className="empty-state">Još nema prodanih artikala.</div>
      )}
    </div>
  );
};

export default KonobarStats;
